import { useContext } from 'react';
import { useQueryClient } from '@tanstack/react-query';
import { AuthContext, PERMISSION_LIST_URL } from 'src/compass/site/providers';
import { IFeatureFlags } from 'src/compass/site/util';

// The flags arrive with the user's permissions, which AuthContextProvider loads before any page
// mounts - so a page can read them straight away, with no loading state of its own. A flag is on
// when it is on for everyone or the user is in its "Also on for" list (the impersonated user's,
// while impersonating). Empty on public routes, so every flag reads as off there.
export default function useFeatureFlags(): Partial<IFeatureFlags> {
  return useContext(AuthContext).featureFlags;
}

// Saving the flags refetches the permissions, so the admin sees the change without a reload.
// Everyone else gets it on their next page load.
export const useFeatureFlagsInvalidateQuery = () => {
  const queryClient = useQueryClient();

  return () => {
    queryClient.invalidateQueries({ queryKey: [PERMISSION_LIST_URL] });
  };
};
